/** @jsx isolateComponent */

import { Fragment, useState } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { formatDateTime } from '@zapier/date';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import { TrialExtensionPaymentMethodModal } from '@zapier/design-system-revenue/src/components/other';

import { Interval } from '@zapier/design-system-revenue/src/types';

import { buildUpgradeUrl } from '@zapier/design-system-revenue/src/utils';

import { ExtendTrialButton } from '../ExtendTrialButton';

type Props = {
  currentPlanName: string;
  onBack?: () => void;
  onClick?: () => void;
  onExtendTrial: () => void;
  trialPlanAmount: number;
  trialPlanInterval: Interval;
  trialPlanName: string;
};

export const TrialExtensionPaymentMethodModalTrigger = ({
  currentPlanName,
  onBack,
  onClick = () => {},
  onExtendTrial,
  trialPlanAmount,
  trialPlanInterval,
  trialPlanName,
}: Props) => {
  const [
    isShowingTrialExtensionPaymentMethodModal,
    setIsShowingTrialExtensionPaymentMethodModal,
  ] = useState(false);

  const { trackEvent } = useTrackingContext();
  const sevenDaysFromToday = new Date().setDate(new Date().getDate() + 7);

  const monthlyAmount =
    trialPlanInterval === 'year' ? trialPlanAmount / 12 : trialPlanAmount;

  const eventProperties = {
    planName: trialPlanName,
    price: monthlyAmount,
    renewalDate: formatDateTime(sevenDaysFromToday, 'iso'),
    upgradeUrl: buildUpgradeUrl(
      currentPlanName,
      trialPlanName,
      trialPlanInterval
    ),
  };

  const handleClose = () => (onBack ? onBack() : onClick());

  return (
    <Fragment>
      <ExtendTrialButton
        onClick={() => {
          setIsShowingTrialExtensionPaymentMethodModal(true);
        }}
      />

      {isShowingTrialExtensionPaymentMethodModal && (
        <TrialExtensionPaymentMethodModal
          monthlyAmount={monthlyAmount}
          onClose={handleClose}
          onContinue={() => {
            trackEvent('editor trial extension activated', eventProperties);
            onExtendTrial();
          }}
          trialEndDate={sevenDaysFromToday}
          trialPlanName={trialPlanName}
        />
      )}
    </Fragment>
  );
};
